/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.WithdrawMyAccountResponse | undefined, (params: WithdrawMyAccount) => void, () => void];

export type WithdrawMyAccount = {
  Token: string;
  Currency: string;
  ClientAccountID?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
};

function usePostWithdrawMyAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<WithdrawMyAccount>();
  const [response, setResponse] = useState<vp.WithdrawMyAccountResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: WithdrawMyAccount) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const responseWithdraw = await api.postWithdrawMyAccount(
        {
          Amount: requestParams.Amount || 0,
          Currency: requestParams.Currency,
          ClientReferenceNumber: requestParams.ClientReferenceNumber,
          Notes: requestParams.Notes,
          ClientAccountID: requestParams.ClientAccountID,
        },
        source,
      );
      setResponse(responseWithdraw);
      setSendRequest(false);
      setDataFetchingInfo(false);
      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: WithdrawMyAccount) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostWithdrawMyAccount);
